import {useState, useEffect} from 'react';
import StepperNav from './StepperNav';

const StepperNavController = ({startStep, ...props}) => {
  const {currentStep} = props;
  const [lastStep, setLastStep] = useState(0);

  useEffect(() => {
    setLastStep(Math.max(currentStep, lastStep));
  }, [currentStep]);

  return () => StepperNav({...props, lastStep});
};

export default (props) => StepperNavController(props)();
